// extracted by mini-css-extract-plugin
export default {"field":"wKfqipkG5xaklAs53li1","label":"jPzsttA6ytdSlcp6oDmP","error":"w5XmggrdIPT15Zx_C4uD","small":"KvBwGDk89YLvNsT97M6b","input":"KIRul_8KiKXCcX_cY_sJ"};